import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import * as R from 'ramda';
import classNames from 'classnames';

import {
  encodeSVG,
  getPaymentMethodIcon,
  isEmptyOrNil
} from 'core/helpers';
import { FormattedTag } from 'core/components';
import { PAYMENT_METHODS, BANKING_HISTORY_TYPES } from 'core/constants';
import { formatAmountWithCurrency } from 'helpers/numbers';
import { IconArrowRightCorner } from 'components/icons/icon-arrow-right-corner';

import './payment-method-list.scss';

const getMethodsWithoutDefaultIcons = currencies => [
  {
    paymentMethod: PAYMENT_METHODS.IS_MBWAYHP,
    allowedCurrencies: currencies,
    icon: '/assets/public/images/interac-e-transfer.svg',
  },
  {
    paymentMethod: 'IS_NETBANKING_5',
    allowedCurrencies: ['INR'],
    icon: '/assets/public/images/netbanking.svg',

  },
];

const { DEPOSIT, WITHDRAWAL } = BANKING_HISTORY_TYPES;

export class PaymentMethod extends Component {
  static propTypes = {
    locale: PropTypes.string,
    className: PropTypes.string,
    currency: PropTypes.string,
    onClick: PropTypes.func,
    paymentMethod: PropTypes.string.isRequired,
    minimum: PropTypes.number,
    maximum: PropTypes.number,
    // isSmall: PropTypes.bool,
    disabled: PropTypes.bool,
    // isIconOnly: PropTypes.bool,
    isPaymentsPage: PropTypes.bool,
    isWithdrawal: PropTypes.bool,
    currencies: PropTypes.arrayOf(PropTypes.shape()),
    isVerificationRequired: PropTypes.bool,
    isModal: PropTypes.bool,
    activePaymentMethod: PropTypes.string,
  };

  static defaultProps = {
    locale: null,
    className: '',
    // isSmall: false,
    onClick: null,
    minimum: null,
    maximum: null,
    currency: '',
    disabled: false,
    // isIconOnly: false,
    isPaymentsPage: false,
    isWithdrawal: false,
    currencies: [],
    isModal: false,
    isVerificationRequired: false,
    activePaymentMethod: '',
  };

  state = {
    isMounted: false,
  };

  componentDidMount() {
    this.setState({ isMounted: true });
  }

  render() {
    const {
      paymentMethod,
      onClick,
      currency,
      minimum,
      locale,
      maximum,
      disabled,
      isPaymentsPage,
      className,
      isWithdrawal,
      currencies,
      isVerificationRequired,
      activePaymentMethod,
      isModal
    } = this.props;

    const { isMounted } = this.state;

    if (!isMounted) {
      return null;
    }

    const withoutDefaultPaymentIcon = isWithdrawal
      ? R.compose(
        R.propOr(null, 'icon'),
        R.last,
        R.filter(
          R.where({
            paymentMethod: R.equals(paymentMethod),
            allowedCurrencies: R.includes(currency),
          }),
        ),
        getMethodsWithoutDefaultIcons,
      )(currencies)
      : null;

    const icon = getPaymentMethodIcon(paymentMethod) || null;
    const currentPaymentType = isWithdrawal ? WITHDRAWAL : DEPOSIT;
    const iconSrc = !R.isNil(icon) && icon.includes('<svg') ? `data:image/svg+xml;utf8,${encodeSVG(icon)}` : icon;
    const isActive = paymentMethod === activePaymentMethod;

    return (
      <button
        type="button"
        onClick={onClick}
        color="transparent"
        disabled={disabled}
        data-name={paymentMethod}
        className={classNames('payment-item p-0 pl-0_5 d-flex rounded w-100 align-items-center', className, { 'payment-item-active': isActive, 'bg-gray-blue': isModal })}
      >
        <>
          {!R.isNil(icon) && (
            <div className="payment-item-icon rounded my-0_5 ml-0_5 mr-2">
              <img
                width={68}
                height={48}
                alt={paymentMethod}
                src={`${!isEmptyOrNil(withoutDefaultPaymentIcon) ? withoutDefaultPaymentIcon : iconSrc} `}
              />
            </div>
          )}

          <div className="d-flex w-100 align-items-center justify-content-between">
            <div className="payment-item-details d-flex flex-column mr-1_5">
              <div className="h4 text-white mb-0_75 text-left font-weight-normal text-truncate">
                <FormattedMessage id={`profile.deposit-new.payment-method.${paymentMethod}`} />
              </div>
              <div className="overflow-auto h5 d-flex flex-column text-gray-5 font-weight-normal text-break">
                {R.isNil(icon) && !isPaymentsPage && (
                  <FormattedTag
                    id={`payments.table.type.${currentPaymentType.toLowerCase()}.${(paymentMethod || '').toLowerCase()}`}
                    className={classNames('payment-item-name h4')}
                  />
                )}
                {!!currency && !!minimum && !!maximum && !isPaymentsPage && (
                  <div
                    className="d-flex text-white-75 text-nowrap text-capitalize h5 w-100 flex-nowrap"
                  >
                    <div className="mr-1">
                      <FormattedMessage id="min" />:
                      <span>&#32;</span>
                      <div className="d-inline-flex text-white font-weight-semi-bold text-truncate">
                        {formatAmountWithCurrency({
                          amount: minimum,
                          currency,
                          locale,
                        })}
                      </div>
                    </div>

                    <div className="d-flex text-truncate">
                      <FormattedMessage id="max" />:
                      <span className="mr-0_25">&#32;</span>
                      <div className="text-white font-weight-semi-bold text-truncate">
                        {formatAmountWithCurrency({
                          amount: maximum,
                          currency,
                          locale,
                        })}
                      </div>
                    </div>
                  </div>
                )}
                {(isWithdrawal && isVerificationRequired) && (
                  <FormattedTag
                    tag="div"
                    id="profile-wallet.withdrawal.verification-required"
                    className="payment-item-verification-message mt-md-1_5 font-weight-semi-bold text-nowrap"
                  />
                )}
              </div>
            </div>

            <div className="mr-2">
              <IconArrowRightCorner color={isActive ? '#fed700' : '#4d4d4d'} />
            </div>
          </div>
        </>
      </button>
    );
  }
}
